import PdfIcon from "@/assets/icons/pdf-select.svg";
import { Button, Icon, Typography } from "@/components/atoms";
import { getGoogleDriveDownloadUrl } from "@/utils";
import { quickSetupContent } from "../../QuickSetup/data/quickSetupContent";

const guide = quickSetupContent.soloOnboarding.guide;
const guideDownloadUrl = getGoogleDriveDownloadUrl(guide.pdfUrl);

/**
 * A direct download link rather than a modal like the per-section guides, because Figma
 * 11573:108963 gives this card a single Download PDF button.
 *
 * `mt-auto` pins the strip to the pane's bottom edge; the negative left margin carries its top
 * border across the pane's own left border. `bg-primary-light` is branded — `useBranding` overrides
 * it per operator at runtime — so it stays a token rather than the design's hex.
 *
 * `xl:sticky xl:bottom-0` keeps the strip on screen while the page scrolls, without making the pane
 * a scroll container — the pane still flows to its own bottom, and the strip settles back onto that
 * bottom edge once it comes into view. Sticky only at xl: once the panes stack the strip is just the
 * end of the stacked column, so it flows. `bg-white` is required, not decorative — a sticky element
 * paints over the static reference content, so a transparent strip would show it through.
 */
export const OnboardingGuideCard = () => (
  <div className="mt-auto flex w-full flex-col gap-4 border-t border-neutral-mid-gray bg-white px-5 py-4 xl:sticky xl:bottom-0 xl:-ml-px xl:w-[calc(100%+1px)]">
    <div className="flex items-center gap-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded bg-primary-light">
        <img src={PdfIcon} alt="" className="h-6 w-6" />
      </div>
      <div className="flex flex-1 flex-col gap-0.5">
        <Typography variant="action" className="!leading-5 text-neutral-dark-gray">
          Complete Onboarding Guide
        </Typography>
        <Typography variant="small-regular" className="!font-medium !leading-4 text-neutral-dark-gray">
          Step-by-step walkthrough for Solo operators
        </Typography>
      </div>
    </div>
    <a href={guideDownloadUrl} target="_blank" rel="noreferrer" className="w-full">
      <Button
        variant="secondary"
        size="sm"
        startIcon={<Icon name="ImportCurve" size="md" aria-hidden="true" />}
        className="w-full justify-center"
      >
        Download PDF
      </Button>
    </a>
  </div>
);
